export default {
  appTitle: 'Web Mobile - Carrière du Lessus',
  imagesProxyUrl: 'https://imagesproxy.mimatech.ch'
}
